import invariant from 'tiny-invariant'

import GlobalStyle from './GlobalStyle'
import ThemeProvider from './Provider'
import { DEFAULT_VARIANT } from './types'

function createGetParam<
  TParams,
  TProps extends Partial<Record<string, any>> = Record<string, any>,
>(params: TParams) {
  return (paramName: keyof TParams) => (props: TProps) => {
    const variants = params?.[paramName] as Record<string, unknown>

    invariant(
      variants,
      `Variant "${paramName as string}" should be defined in params`,
    )

    let prop = DEFAULT_VARIANT

    Object.entries(props).forEach(([key, value]) => {
      if (value && Object.prototype.hasOwnProperty.call(variants, key)) {
        prop = key
      }
    })

    const result = variants[prop]
    return typeof result === 'function' ? result(props) : result
  }
}

export { createGetParam, GlobalStyle, ThemeProvider }
